import React from "react";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";
import Location from "../location/Location";
import Footer from "../footer/Footer";
import "./AboutUs.css";

import {
  FaPhone,
  FaWhatsapp,
  FaTools,
  FaCouch,
  FaAward,
  FaClock,
  FaArrowRight,
  FaLayerGroup,
  FaWrench,
} from "react-icons/fa";

export default function AboutUs() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const whatsappURL = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
    "Hello RK Sofa Works, I need sofa repair / upholstery service."
  )}`;

  return (
    <>
      <Navbar />

      {/* =====================================================
          ABOUT HERO
      ===================================================== */}
      <section
        className="rk-about-hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/img1.jpg)`,
        }}
      >
        <div className="rk-about-hero-overlay"></div>

        <div className="rk-about-hero-texture"></div>

        <div className="container rk-about-container">
          <div className="rk-about-hero-grid">

            <div className="rk-about-hero-content">
              <div className="rk-about-kicker">
                <span></span>
                <small>RK SOFA WORKS</small>
              </div>

              <div className="rk-about-hero-number">ABOUT US</div>

              <h1>
                Furniture
                <br />
                deserves a
                <br />
                <em>second life.</em>
              </h1>

              <p>
                We repair, restore and refresh sofas with careful
                workmanship, quality materials and a genuine focus
                on everyday comfort.
              </p>

              <div className="rk-about-hero-actions">
                <a
                  href={`tel:${PHONE}`}
                  className="rk-about-primary-btn"
                >
                  <FaPhone />
                  <span>Talk to Us</span>
                  <FaArrowRight />
                </a>

                <a
                  href={whatsappURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rk-about-outline-btn"
                >
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>

            {/* FLOATING INFO */}
            <div className="rk-about-floating-card">
              <div className="rk-floating-top">
                <span>CRAFT</span>
                <span></span>
              </div>

              <div className="rk-floating-icon">
                <FaCouch />
              </div>

              <strong>18+</strong>

              <p>
                Years of
                <br />
                experience
              </p>

              <div className="rk-floating-line"></div>

              <small>
                Sofa repair
                <br />
                & restoration
              </small>
            </div>
          </div>
        </div>

        {/* HERO BOTTOM */}
        <div className="rk-about-hero-bottom">
          <div className="container rk-about-container">
            <div className="rk-about-stat-row">

              <div className="rk-about-stat">
                <FaCouch />
                <div>
                  <strong>2,500+</strong>
                  <span>Sofas Repaired</span>
                </div>
              </div>

              <div className="rk-about-stat">
                <FaAward />
                <div>
                  <strong>18+</strong>
                  <span>Years Experience</span>
                </div>
              </div>

              <div className="rk-about-stat">
                <FaTools />
                <div>
                  <strong>100%</strong>
                  <span>Quality Work</span>
                </div>
              </div>

              <div className="rk-about-stat">
                <FaClock />
                <div>
                  <strong>On-Time</strong>
                  <span>Service</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


      {/* =====================================================
          OUR STORY
      ===================================================== */}
      <section className="rk-story-section">
        <div className="container rk-about-container">

          <div className="rk-story-grid">

            {/* IMAGE SIDE */}
            <div className="rk-story-visual">

              <div className="rk-story-image-frame">
                <img
                  src={`${process.env.PUBLIC_URL}/img/sofa_1.jpeg`}
                  alt="RK Sofa Works sofa restoration"
                />

                <div className="rk-image-caption">
                  <span>RK SOFA WORKS</span>
                  <strong>CRAFTED WITH CARE</strong>
                </div>
              </div>

              <div className="rk-story-side-note">
                <span>EST.</span>
                <strong>RK</strong>
                <small>SOFA<br />WORKS</small>
              </div>

              <div className="rk-story-stamp">
                <FaCouch />
                <span>RESTORE</span>
                <span>REFRESH</span>
              </div>

            </div>


            {/* CONTENT SIDE */}
            <div className="rk-story-content">

              <div className="rk-section-kicker">
                <small>OUR STORY</small>
              </div>

              <h2>
                More than repair.
                <br />
                <em>We restore comfort.</em>
              </h2>

              <p className="rk-story-lead">
                A sofa is more than a piece of furniture. It is where
                people relax, talk, work, watch movies and spend time
                together.
              </p>

              <p>
                With over 18 years of experience in sofa repair and
                reupholstery, RK Sofa Works focuses on bringing worn
                furniture back into useful, comfortable condition.
              </p>

              <p>
                From fabric and foam replacement to spring repair,
                frame strengthening and complete restoration, our
                craftsmen work on the details that make a difference
                to the final result.
              </p>


              {/* FEATURE LIST */}
              <div className="rk-story-features">

                <div className="rk-story-feature">
                  <div className="rk-feature-icon">
                    <FaTools />
                  </div>

                  <div>
                    <strong>Experienced Craftsmanship</strong>
                    <span>
                      Skilled work with attention to small details.
                    </span>
                  </div>
                </div>

                <div className="rk-story-feature">
                  <div className="rk-feature-icon">
                    <FaLayerGroup />
                  </div>

                  <div>
                    <strong>Quality Materials</strong>
                    <span>
                      Carefully selected fabric, foam and accessories.
                    </span>
                  </div>
                </div>

                <div className="rk-story-feature">
                  <div className="rk-feature-icon">
                    <FaWrench />
                  </div>

                  <div>
                    <strong>Complete Solutions</strong>
                    <span>
                      Repair, upholstery, cushions and sofa makeover.
                    </span>
                  </div>
                </div>

                <div className="rk-story-feature">
                  <div className="rk-feature-icon">
                    <FaClock />
                  </div>

                  <div>
                    <strong>Convenient Service</strong>
                    <span>
                      Professional service designed around your needs.
                    </span>
                  </div>
                </div>

              </div>


              <a
                href="/contact_us"
                className="rk-story-button"
              >
                <span>Start Your Sofa Project</span>
                <FaArrowRight />
              </a>

            </div>
          </div>
        </div>
      </section>


      {/* =====================================================
          PHILOSOPHY STRIP
      ===================================================== */}
      <section className="rk-philosophy">
        <div className="container rk-about-container">

          <div className="rk-philosophy-inner">

            <div className="rk-philosophy-number">
              
            </div>

            <div className="rk-philosophy-copy">
              <span>OUR APPROACH</span>

              <h2>
                Repair with purpose.
                <br />
                Restore with patience.
              </h2>
            </div>

            <div className="rk-philosophy-text">
              <p>
                We believe good sofa restoration is about balancing
                structure, comfort and appearance — not simply making
                old furniture look new.
              </p>

              <div className="rk-philosophy-line"></div>

              <span>REPAIR • RESTORE • REFRESH</span>
            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          WHY RK
      ===================================================== */}
      <section className="rk-why-section">
        <div className="container rk-about-container">

          <div className="rk-why-heading">

            <div className="rk-section-kicker">
              <span></span>
              <small>WHY RK SOFA WORKS</small>
            </div>

            <div>
              <h2>
                Built around
                <br />
                <em>better comfort.</em>
              </h2>
            </div>

            <p>
              Professional workmanship, quality materials and
              customer-focused service come together in every project.
            </p>

          </div>


          <div className="rk-why-grid">

            <article className="rk-why-card rk-why-card-large">
              <div className="rk-card-number"></div>

              <div className="rk-why-icon">
                <FaTools />
              </div>

              <h3>Expert Craftsmanship</h3>

              <p>
                Our craftsmen handle sofa repair and restoration
                with practical attention to structure, finish and
                comfort.
              </p>

              <div className="rk-card-arrow">
                <FaArrowRight />
              </div>
            </article>


            <article className="rk-why-card">
              <div className="rk-card-number"></div>

              <div className="rk-why-icon">
                <FaCouch />
              </div>

              <h3>Complete Sofa Solutions</h3>

              <p>
                From small repairs to complete reupholstery,
                we work on different parts of your sofa.
              </p>

              <div className="rk-card-arrow">
                <FaArrowRight />
              </div>
            </article>


            <article className="rk-why-card">
              <div className="rk-card-number"></div>

              <div className="rk-why-icon">
                <FaAward />
              </div>

              <h3>Premium Materials</h3>

              <p>
                Quality fabrics, foam, springs and supporting
                materials help improve the final finish.
              </p>

              <div className="rk-card-arrow">
                <FaArrowRight />
              </div>
            </article>


            <article className="rk-why-card rk-why-card-accent">
              <div className="rk-card-number"></div>

              <div className="rk-why-icon">
                <FaClock />
              </div>

              <h3>Reliable Service</h3>

              <p>
                We aim to keep the process clear, convenient and
                aligned with the promised schedule.
              </p>

              <div className="rk-card-arrow">
                <FaArrowRight />
              </div>
            </article>

          </div>
        </div>
      </section>


      {/* =====================================================
          SERVICES MINI STRIP
      ===================================================== */}
      <section className="rk-service-strip">
        <div className="container rk-about-container">

          <div className="rk-service-strip-title">
            <span></span>
            <strong>WHAT WE WORK ON</strong>
          </div>

          <div className="rk-service-items">

            <div>
              <FaCouch />
              <span>Sofa Repair</span>
            </div>

            <div>
              <FaLayerGroup />
              <span>Re-Upholstery</span>
            </div>

            <div>
              <FaTools />
              <span>Foam & Cushion</span>
            </div>

            <div>
              <FaWrench />
              <span>Frame & Spring</span>
            </div>

          </div>

        </div>
      </section>


      <Offer />

      <Location />

      <Footer />
    </>
  );
}